import { render, staticRenderFns } from "./Changedepto.vue?vue&type=template&id=4099a052&scoped=true&"
import script from "./Changedepto.vue?vue&type=script&lang=js&"
export * from "./Changedepto.vue?vue&type=script&lang=js&"
import style0 from "./Changedepto.vue?vue&type=style&index=0&id=4099a052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4099a052",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VApp,VBtn,VContainer,VSelect,VTextarea})
